import { globalWindow } from './global';
export var isMiniAli = typeof my !== 'undefined' && !!my && typeof my.showToast === 'function' && my.isFRM !== true;
export default !isMiniAli ? globalWindow.devicePixelRatio : my.getSystemInfoSync().pixelRatio;
//# sourceMappingURL=devicePixelRatio.js.map